import {
  TIME_SUMMARY_REPORT,
  TIME_GRAPH_REPORT,
  DAY_SUMMARY_REPORT,
  DAY_GRAPH_REPORT,
  OPERATOR_DETAIL_REPORT,
  OPERATOR_SUMMARY_REPORT,
  PART_DETAIL_REPORT,
  PART_SUMMARY_REPORT,
  PERFORMANCE_REPORT,
  PNL_REPORT
} from "../../constants/apis";
import { getUrl, replaceMultiple } from "../../utilities/helpers";

export const fetchTimeSummaryReport =
  (filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(TIME_SUMMARY_REPORT, filters);
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchTimeGraphReport =
  (filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(TIME_GRAPH_REPORT, filters);
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchDayReportGraph =
  (filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(DAY_GRAPH_REPORT, filters);
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchDaySummaryReport =
  (filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(DAY_SUMMARY_REPORT, filters);
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchOperatorDetailReport =
  (uuid, filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(
      replaceMultiple(OPERATOR_DETAIL_REPORT, {
        "{{uuid}}": uuid,
      }),
      filters
    );
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchOperatorSummaryReport =
  (filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(OPERATOR_SUMMARY_REPORT, filters);
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchPartDetailReport =
  (uuid, filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(
      replaceMultiple(PART_DETAIL_REPORT, {
        "{{uuid}}": uuid,
      }),
      filters
    );
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchPartSummaryReport =
  (filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(PART_SUMMARY_REPORT, filters);
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchPerformanceReport =
  (uuid, filters) =>
  (dispatch, getState, { apiReport }) => {
    const url = getUrl(
      replaceMultiple(PERFORMANCE_REPORT, {
        "{{uuid}}": uuid,
      }),
      filters
    );
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchPnlReport =
  (query) =>
  (dispatch, getState, { apiReport }) => {
    const finalUrlPath = getUrl(PNL_REPORT, query);
    return apiReport
      .get(finalUrlPath)
      .then((result) => result)
      .catch((error) => {
        console.error("Error fetching company staffs:", error);
        throw error;
      });
  };